import { c as _c } from "react/compiler-runtime";
import { apiService } from "@/services/api";
import { useQuery } from "@tanstack/react-query";
export function useFaqsTypesQuery(slug, country, city, shouldSkip) {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["faqsTypes"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== city || $[2] !== country || $[3] !== slug) {
    t1 = () => apiService.getFaqsTypes(slug, country, city);
    $[1] = city;
    $[2] = country;
    $[3] = slug;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !shouldSkip;
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
}